import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: "/", label: t("nav.home") },
    { to: "/category/all", label: t("nav.categories") },
    { to: "/about", label: t("nav.about") },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="container-site flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className="flex items-center gap-2 z-10"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span
            className="text-2xl font-bold font-heading tracking-tight"
            style={{
              background: scrolled
                ? "linear-gradient(135deg, oklch(0.65 0.155 30), oklch(0.74 0.135 48))"
                : "linear-gradient(135deg, hsl(0 0% 98%), hsl(40 60% 85%))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("site.name")}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.to
                  ? "text-primary-500"
                  : scrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className="md:hidden z-10 flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`text-xl ${
              scrolled ? "text-foreground-800" : "text-white"
            } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
          ></i>
        </button>

        {mobileOpen && (
          <div className="md:hidden fixed inset-0 top-0 bg-background-50 z-[5] flex flex-col items-center justify-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-xl font-heading font-semibold transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to
                    ? "text-primary-500"
                    : "text-foreground-800 hover:text-primary-500"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}